import Constants from "../Constants/Constants";
export const low_stock_warehouse = `SELECT w.id AS id from "Products" p
                                    inner join "WarehouseStock" w on p.id = w."productId"
                                     WHERE w."totalQty" <= p."lowStockThreshold" AND w."totalQty" > 0`;

export function users_summary_statement(startDate, endDate) {
    return  ` from "Users" u
              inner join
               "Customers" c on u.id = c."salesExecutiveId"
              inner join
               (
                 select o.id, o."toCustomerId", o."payableAmount", sum(oi.qty) as TotalQtyPerOrder
                 from ("Orders" o inner join "OrderItems" oi on oi."orderId" = o.id)
                 where o."created_at" >= '${startDate}' AND o."created_at" <= '${endDate}' AND 
                       o."statusId" = '${Constants.OrderStatuses.Delivered}'                        
                 group by o.id, o."toCustomerId", o."payableAmount"
               ) as b on c.id = b."toCustomerId"                        
               where u."roleId" = '${Constants.UserRoles.SalesExecutive}' 
               group by u.id`;
}

export const users_summary_aggregate = `json_build_object('count', COUNT(*), 'sum', json_build_object('payableAmount', sum(b."payableAmount"), 'totalQty', sum(TotalQtyPerOrder)))`;

export function reserved_stock_customers_statement(productId, warehouseId) {
    return  ` from (("Customers" c inner join "OrderItems" oi on c.id = oi."toCustomerId")
            inner join "Orders" o on o.id = oi."orderId")
            WHERE o."statusId" NOT IN ('${Constants.OrderStatuses.Delivered}','${Constants.OrderStatuses.Canceled}') AND 
                  oi."productId" = '${productId}' AND 
                  oi."fromWarehouseId" = '${warehouseId}'  
            GROUP BY c.id`;
}

export const reserved_stock_customers_aggregate = `json_build_object('sum', json_build_object('qty', sum(oi."qty")))`;

export function products_with_multi_branch_statement(startDate, endDate) {
    return  ` from ((select oi."fromWarehouseId", oi."productId", count(*) as countval, sum(oi."qty") as sumQty, sum(oi."totalPrice") as sumTotalPrice, count(distinct oi."toCustomerId") as countCustomer
                from ("OrderItems" oi inner join "Orders" o on o.id = oi."orderId")
                where o."created_at" >= '${startDate}' AND o."created_at" <= '${endDate}' and 
                      o."statusId" = '${Constants.OrderStatuses.Delivered}' 
                group by oi."fromWarehouseId", oi."productId"
                ) t inner join "Products" p on p.id = t."productId")
             group by p.id`;
}

export const products_with_multi_branch_aggregate = `json_build_object('totalQty', sum(sumQty), 'totalPrice', sum(sumTotalPrice), 'numOfCustomers', sum(countCustomer), 'branches', json_agg(json_build_object('warehouseId', t."fromWarehouseId", 'sumQty' , sumQty, 'sumTotalPrice' , sumTotalPrice, 'countCustomer' , countCustomer)))`;

export function no_sold_products_count_statement(startDate, endDate, warehouseId, hideZeroStockProduct) {
    return  ` from "Products" p inner join "WarehouseStock" ws on p.id = ws."productId"
                where p."isDeleted" = false and 
                      p.id NOT IN (select pd.id from (("Products" pd inner join "OrderItems" oi on pd.id = oi."productId")
                                                        inner join "Orders" o on o.id = oi."orderId")
                                                        where o."created_at" >= '${startDate}' AND o."created_at" <= '${endDate}' AND 
                                                        o."statusId" = '${Constants.OrderStatuses.Delivered}' AND
                                                        oi."fromWarehouseId" = '${warehouseId}'
                                  ) and
                      ws."warehouseId" = '${warehouseId}' ${hideZeroStockProduct?'and ws."totalQty" > 0':''} `;
}
export function no_sold_products_statement(startDate, endDate, warehouseId, hideZeroStockProduct, orderBy) {
    return  ` from "Products" p inner join "WarehouseStock" ws on p.id = ws."productId"
                where p."isDeleted" = false and 
                      p.id NOT IN (select pd.id from (("Products" pd inner join "OrderItems" oi on pd.id = oi."productId")
                                                        inner join "Orders" o on o.id = oi."orderId")
                                                        where o."created_at" >= '${startDate}' AND o."created_at" <= '${endDate}' AND 
                                                        o."statusId" = '${Constants.OrderStatuses.Delivered}' AND
                                                        oi."fromWarehouseId" = '${warehouseId}'
                                  ) and
                      ws."warehouseId" = '${warehouseId}' ${hideZeroStockProduct?'and ws."totalQty" > 0':''}
                      ${orderBy} `;
}

export const no_sold_products_aggregate = `p.aggregate`;

export function purchase_recent_products_statement(startDate, endDate, orderBy, search) {
    return  ` from "Products" as p
              inner join
              (
                select sh."productId", sum(sh.quantity) as StockAdded
                from ("StockHistory" sh inner join "StockOrder" so on sh."stockOrderId" = so.id)
                where so."type" = 1 AND so."created_at" >= '${startDate}' AND so."created_at" <= '${endDate}'                       
                group by sh."productId"
              ) as b on p.id = b."productId"
              inner join
              (
                select ws."productId", sum(ws."totalQty") as StockAvailable
                from "WarehouseStock" ws    
                group by ws."productId"
              ) as i on p.id = i."productId"
              where p."isDeleted" = false AND b.StockAdded > 0 ${search}
              ${orderBy} `;
}

export const purchase_recent_products_aggregate = `json_build_object('sum', json_build_object('StockAvailable', StockAvailable, 'StockAdded', StockAdded))`;
export const purchase_recent_products_aggregate_summary = `json_build_object('count', count(*) over(),'avg', json_build_object('StockAvailable', avg(StockAvailable) over(), 'StockAdded', avg(StockAdded) over(), 'purchasePrice', avg(p."purchasePrice") over(), 'displayPrice', avg(p."displayPrice") over(), 'margin', avg(p."margin") over()))`;

export function purchase_recent_products_count_statement(startDate, endDate) {
    return  ` from "Products" as p
              inner join
              (
                select sh."productId", sum(sh.quantity) as StockAdded
                from ("StockHistory" sh inner join "StockOrder" so on sh."stockOrderId" = so.id)
                where so."type" = 1 and so."created_at" >= '${startDate}' AND so."created_at" <= '${endDate}'                        
                group by sh."productId"
              ) as b on p.id = b."productId" 
              where p."isDeleted" = false AND b.StockAdded > 0`;
}

export function purchase_all_products_statement(orderBy, search) {
    return  ` from "Products" as p              
              inner join
              (
                select ws."productId", sum(ws."totalQty") as StockAvailable
                from "WarehouseStock" ws    
                group by ws."productId"
              ) as i on p.id = i."productId"
              where p."isDeleted" = false ${search}
              ${orderBy}`;
}

export const purchase_all_products_aggregate = `json_build_object('sum', json_build_object('StockAvailable', StockAvailable))`;
export const purchase_all_products_aggregate_summary = `json_build_object('count', count(*) over(),'avg', json_build_object('StockAvailable', avg(StockAvailable) over(), 'purchasePrice', avg(p."purchasePrice") over(), 'displayPrice', avg(p."displayPrice") over(), 'margin', avg(p."margin") over()))`;

export function purchase_new_products_statement(orderBy, search) {
    return  ` from "Products" as p              
              inner join
              (
                select ws."productId", sum(ws."totalQty") as StockAvailable
                from "WarehouseStock" ws    
                group by ws."productId"
              ) as i on p.id = i."productId"
              where p."isDeleted" = false  and
                    p."purchasePrice" = 0 ${search}
              ${orderBy} `;
}

export const purchase_new_products_aggregate = `json_build_object('sum', json_build_object('StockAvailable', StockAvailable))`;
export const purchase_new_products_aggregate_summary = `json_build_object('count', count(*) over(),'avg', json_build_object('StockAvailable', avg(StockAvailable) over(), 'purchasePrice', avg(p."purchasePrice") over(), 'displayPrice', avg(p."displayPrice") over(), 'margin', avg(p."margin") over()))`;

export function profit_loss_products_statement(startDate, endDate, warehouseId) {
    return  ` from "Products" as p              
              inner join
              (
                select oi."productId", sum(oi."qty") as totalQty, sum(oi."qty" * oi."pricePerUnit") as totalSaleAmount, sum(oi."qty" * oi."purchasePricePerUnit") as totalPurchaseAmount
                from ("OrderItems" oi inner join "Orders" o on oi."orderId" = o.id)
                where o."created_at" >= '${startDate}' AND o."created_at" <= '${endDate}' and 
                      o."fromWarehouseId" = '${warehouseId}' and o."statusId" = '${Constants.OrderStatuses.Delivered}'                        
                group by oi."productId"
              ) as b on p.id = b."productId"
              `;
}
export const profit_loss_products_aggregate = `json_build_object('sum', json_build_object('totalQty', totalQty, 'totalSaleAmount', totalSaleAmount, 'totalPurchaseAmount', totalPurchaseAmount), 'avg', json_build_object('avgSalePrice', (totalSaleAmount/totalQty), 'avgPurchasePrice', (totalPurchaseAmount/totalQty)), 'profitAmount', (totalSaleAmount-totalPurchaseAmount), 'profitPercent', ((totalSaleAmount-totalPurchaseAmount)/totalPurchaseAmount))`;

export const search_product_aggregate = `json_build_object('warehouse', json_build_object('totalQty', w."totalQty", 'reservedQty', w."reservedQty", 'stock_out_at', w."stock_out_at"))`;

export function purchase_request_products_statement(date, where = '', orderBy = '') {
    return  ` from "Products" as p              
              inner join
              (
                select pr."productId", pr."orderedDate", min(pr."rate") as minRate, count(*) as totalRequest, max(pr."created_at") as recentDate, 
                       count(CASE WHEN pr."statusId" = '${Constants.PRQStatuses.Pending}' THEN 1 ELSE NULL END) as pendingRequest,
                       count(CASE WHEN pr."statusId" = '${Constants.PRQStatuses.Confirmed}' OR pr."statusId" = '${Constants.PRQStatuses.Received}' THEN 1 ELSE NULL END) as confirmedRequest                      
                from "PurchaseRequest" pr
                where pr."orderedDate" = '${date}'    
                group by pr."productId", pr."orderedDate"
              ) as i on p.id = i."productId"
              ${where}
              ${orderBy}`;
}

export const purchase_request_products_aggregate = `json_build_object('totalRequest', totalRequest, 'pendingRequest', pendingRequest, 'confirmedRequest', confirmedRequest, 'minRate', minRate, 'recentDate', recentDate, 'orderedDate', i."orderedDate")`;
/*
json_build_object('aggregate',
    json_build_object(
        'count', COUNT(*),
        'sum', json_build_object('payableAmount', sum("payableAmount"))
)  AS "aggregate"
 */

// let a = "SELECT u.*, json_build_object('count', COUNT(*), 'sum', json_build_object('payableAmount', sum(o.\"payableAmount\")) AS \"aggregate\" from ((\"Users\" u inner join \"Customers\" c on u.id = c.\"salesExecutiveId\") inner join \"Orders\" o on o.\"toCustomerId\" = c.id) WHERE o.\"created_at\" >= \"2020-10-20T00:00:00+05:30\" AND o.\"created_at\" <= \"2020-10-24T23:59:59+05:30\" AND o.\"statusId\" = \"755514d9-bca2-4560-9a74-5f3e6a34411a\" AND u.roleId = \"97b86621-a2f7-485c-bafc-ac974993d762\" GROUP BY u.id";


// SELECT 'SELECT ' || STRING_AGG('o.' || column_name, ', ') || ' FROM \"Users\" AS o';
// FROM information_schema.columns;
// WHERE table_name = 'Users';
// AND table_schema = 'public';
// AND column_name NOT IN ('id', 'deleted');